var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.routesReady)?_c('div',[_c('LoadingSpinner',{attrs:{"toggle":true}})],1):(_vm.routesReady && _vm.isAuthenticated)?[_c('div',{class:_vm.appConfig.app_classes},[_c('router-view',{key:_vm.$route.fullPath}),_c('modals-container')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }